import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'react-bootstrap';
import { Sprawy } from '../../sprawy/Sprawy';
import Link from '../../../components/Link';
import s from '../../content.scss';
import PaperTile from '../../../components//PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { notFoundImageURL } from '../../../config';
import fetch from '../../../core/fetch';
import { connect } from 'react-redux';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';

class szczegolyEuslugi extends React.Component {
  state = {
    colors: 'normal',
    style: {},
  };

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
        backgroundColor: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style });
  }

  sortUrzedy = (a, b) => {
    const itemA = a.placeOfSettling.toUpperCase();
    const itemB = b.placeOfSettling.toUpperCase();
    if (itemA < itemB) {
      return -1;
    }
    if (itemA > itemB) {
      return 1;
    }
    return 0;
  };
  render() {
    return (
      <div>
        {Object.keys(Sprawy)
          .filter(sprawa => sprawa === this.props.prefix)
          .map((sprawa, index) => (
            <div key={index}>
              <PaperHeader title={Sprawy[sprawa].title} />
              <div className="paper-area" style={this.state.style}>
                <Col xs={12} sm={8}>
                  <Row className="eus-specs">
                    <Col xs={3}>Kogo dotyczy:</Col>
                    <Col xs={9}>{Sprawy[sprawa].dotyczy}</Col>
                  </Row>
                  <Row className="eus-specs">
                    <Col xs={3}>Czas realizacji:</Col>
                    <Col xs={9}>{Sprawy[sprawa].czas}</Col>
                  </Row>
                  <Row className="eus-specs">
                    <Col xs={3}>Wymagane dokumenty:</Col>
                    <Col xs={9}>
                      {Sprawy[sprawa].dokumenty.map((item, i) => (
                        <div key={i}>{item}</div>
                      ))}
                    </Col>
                  </Row>
                  <Row className="eus-specs">
                    <Col xs={3}>Opłaty:</Col>
                    <Col xs={9}>
                      {Sprawy[sprawa].oplaty.map((item, i) => (
                        <div key={i}>{item}</div>
                      ))}
                    </Col>
                  </Row>
                  <Row className="eus-specs">
                    <Col xs={3}>Tryb odwoławczy:</Col>
                    <Col xs={9}>{Sprawy[sprawa].tryb}</Col>
                  </Row>
                  <Row className="eus-specs">
                    <Col xs={3}>Podstawa prawna:</Col>
                    <Col xs={9}>
                      {Object.keys(Sprawy[sprawa].podstawa).length > 0 ? Object.keys(Sprawy[sprawa].podstawa).map((item, i) => (
                        <div key={i} >
                          <a
                            key={i}
                            className="eus-lnk"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={Object.values(Sprawy[sprawa].podstawa)[i]}
                            style={this.state.style}
                          >
                            {item}
                          </a>
                        </div>
                      )) : <div>Nie określono.</div>}
                    </Col>
                  </Row>
                </Col>
              </div>
            </div>
          ))}
        <PaperHeader title="Urzędy lub instytucje udostępniające tę usługę" />
        <Row>
          {this.props.districts && Object.values(this.props.districts)
            .filter(urzad => urzad.showOnList === true)
            .filter(urzad => urzad.services.includes(this.props.prefix))
            .sort(this.sortUrzedy)
            .map((urzad, i) => {
              const start = urzad.teryt === 1020043 ? "eservices" : "eservices";
              return (
                <Col key={i} xs={12} sm={6} md={4}>
                  <PaperTile
                    href={`/${start}?district=${urzad.teryt}&serviceType=${this.props.prefix}`} 
                    text={urzad.name}
                    herb={urzad.herb ?
                    `${process.env.OLD_IHUB}/upload/herby/${urzad.herb}`
                  : notFoundImageURL}
                  />
                </Col>
              );
            })}
        </Row>
      </div>
    );
  }
}

szczegolyEuslugi.propTypes = {
  prefix: PropTypes.string,
};

// eservices?customerId=E819A999-4CAF-45D1-AF89-A38628EBFF6F&district=1815033&serviceType=WypisIWyrysZeStudium
const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default withStyles(s)(connect(mapState)(szczegolyEuslugi));



// WEBPACK FOOTER //
// src/routes/euslugi/szczegolyEuslugi/SzczegolyEuslugi.js